import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=979680a2&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979680a2')) {
      api.createRecord('979680a2', component.options)
    } else {
      api.reload('979680a2', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=979680a2&", function () {
      api.rerender('979680a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GvZ9dS5za3fH/JS/comp/DateRangeExt.vue"
export default component.exports